export default "__VITE_ASSET__BWOarGIA__"